

(function ($) {
    "use strict";
    $(function () {

        if ($(".js-mh-product-title").length) {
            $(".js-mh-product-title").matchHeight({
                byRow: true
            });
        }



        if ($(".js-mh-price").length) {
            $(".js-mh-price").matchHeight({
                byRow: true
            });
        }


        if ($(".js-mh-price-old").length) {
            $(".js-mh-price-old").matchHeight({
                byRow: true
            });
        }


        if ($(".js-mh-card-news").length) {
            $(".js-mh-card-news").matchHeight({
                byRow: true
            });
        }



        $('.js-filter-toggle').on('click', function (e) {
            e.preventDefault();
            $('.js-filter-toggle-wrapper').slideToggle();
        })


        if ($('.js-sidebar').length) {
            $('.js-sidebar').stickySidebar({
                topSpacing: $('header').outerHeight(),
                bottomSpacing: 0,
                containerSelector: '.sidebar__container',
                innerWrapperSelector: '.plus-sidebar-wrapper',
                resizeSensor: true,
                minWidth: 992,
            });
        }



        if ($('.js-product-slider').length) {

            var productSliderThumbs = new Swiper(".js-product-slider-thumbs", {
                loop: false,
                spaceBetween: 20,
                slidesPerView: "auto",
                freeMode: false,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                centeredSlides: true,

            });

            var productSlider = new Swiper(".js-product-slider", {
                loop: false,
                spaceBetween: 11,
                effect: "fade",
                thumbs: {
                    swiper: productSliderThumbs,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        }


        if ($('.js-popular-products').length) {
            var popularProducts = new Swiper(".js-popular-products", {
                slidesPerView: 1,
                spaceBetween: 32,
                navigation: {
                    nextEl: ".js-popular-products-next",
                    prevEl: ".js-popular-products-prev",
                },
                breakpoints: {
                    520: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                },


            });

        }

    });
})(jQuery);